import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { parseNativeGiftOpenUrl } from '../../../pages/GiftVoucherPage/giftExperience';

let lastHandled: { url: string; at: number } | null = null;

function openGiftIfNeeded(rawUrl: string | undefined, navigate: (path: string) => void): boolean {
  if (!rawUrl) return false;
  const path = parseNativeGiftOpenUrl(rawUrl);
  if (!path) return false;
  if (lastHandled && lastHandled.url === rawUrl && Date.now() - lastHandled.at < 2000) {
    return true;
  }
  lastHandled = { url: rawUrl, at: Date.now() };
  navigate(path);
  return true;
}

/** Ouvre `/cadeau/:code` quand le mail ou le QR lance l’app native. */
export function NativeGiftDeepLink() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let remove: (() => void) | undefined;

    const setup = async () => {
      const { App: CapApp } = await import('@capacitor/app');
      const go = (path: string) => navigate(path, { replace: true });

      try {
        const launch = await CapApp.getLaunchUrl();
        openGiftIfNeeded(launch?.url, go);
      } catch {
        /* ignore */
      }

      const handle = await CapApp.addListener('appUrlOpen', data => {
        openGiftIfNeeded(data.url, go);
      });
      remove = () => {
        void handle.remove();
      };
    };

    void setup();
    return () => remove?.();
  }, [navigate]);

  return null;
}
